@if(copierType === 'icon'){
   <svg-icon src="@assets/images/icons/clipboard-document-check.svg" class="block text-neutral-600" [ngClass]="iconSizeClass || 'w-4 h-4'">
   </svg-icon>
}
@if(copierType === 'button'){
   <button [ngClass]="iconSizeClass || 'w-auto h-auto'">{{ copierLabel }}</button>
}
